import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const ScrollablePicksContainer = styled.div<{
  contentHeight: string;
}>`
  overflow-y: auto;
  max-height: 100vh;
  height: ${({ contentHeight }) => contentHeight};
  scroll-behavior: smooth;
  display: flex;
  flex-direction: column;
  gap: var(--fd-space-space-1);
  background-color: ${({ theme }) => theme.colors.blue["000"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    gap: 0;
    flex-direction: row;
    scroll-padding: var(--fd-space-space-3);
    overflow-x: auto;
    overflow-y: hidden;
    max-height: initial;
    scroll-snap-type: x mandatory;
    scroll-snap-stop: always;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const RaceCardWrapper = styled.div`
  height: fit-content;
  flex: none;
  width: 100%;
  overflow: hidden;

  @media screen and ${breakpoints.tablet.max.sm} {
    width: calc(100vw - 24px);
    margin: 0 var(--fd-space-space-1);
    scroll-snap-align: start;

    &:first-of-type {
      margin-left: var(--fd-space-space-3);
    }

    &:last-of-type {
      margin-right: var(--fd-space-space-3);
    }
  }
`;

export const RaceCardPicksContainer = styled.div`
  height: fit-content;
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 4px;
  overflow: hidden;

  @media screen and ${breakpoints.tablet.max.sm} {
    border-radius: 8px;
    border: 1px solid var(--fd-colors-border-default);
    box-shadow: 0 2px 4px 0 rgba(17, 43, 68, 0.14);
    width: 100%;
  }
`;

export const LegsPicker = styled.div`
  padding: var(--fd-space-space-3);
  box-shadow: ${({ theme }) => `inset 0 -2px 0 ${theme.colors.blue["100"]}`};
`;

export const FPPContainer = styled.div`
  margin-left: 13px;
  width: calc(100% - 18px);
  margin-top: 12px;
  box-shadow: 0 2px 4px 0 rgba(17, 43, 68, 0.14);
  border-radius: 8px;
  overflow: hidden;
`;
